import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from '../utils/api';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Create inquiry from contact form
      const response = await axios.post('/inquiries/create', {
        fullName: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        city: 'Not specified',
        insuranceType: 'General Inquiry',
        message: formData.message
      });

      if (response.data.success) {
        toast.success('Thank you! Your message has been sent successfully.');
        setFormData({
          name: '',
          mobile: '',
          email: '',
          message: ''
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* UPDATED HERO SECTION */}
{/* HERO SECTION — EXACT CLAIM PAGE STYLE */}
<section className="contact-hero">
  <div className="contact-hero-flex">

    {/* LEFT TEXT */}
    <div className="contact-hero-left">
      <h1 className="contact-hero-title">Contact Us</h1>
      <p className="contact-hero-subtitle">We're here to help you</p>
    </div>

    {/* RIGHT IMAGE */}
    <div className="contact-hero-right">
      <img
        src="/images/contact-hero-icon.png"
        alt="Contact Support Icon"
        className="contact-hero-img"
      />
    </div>

  </div>
</section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <p>
                Have questions about our insurance products? Need assistance with a claim? 
                Our team is ready to help you. Reach out to us through any of the following ways.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <FaMapMarkerAlt className="contact-icon" />
                  <div>
                    <h3>Address</h3>
                    <p>Vadodara, Gujarat, India</p>
                  </div>
                </div>

                <div className="contact-item">
                  <FaPhone className="contact-icon" />
                  <div>
                    <h3>Phone</h3>
                    <p>+91 70417 11159, +91 88661 41159</p>
                  </div>
                </div>

                <div className="contact-item">
                  <FaEnvelope className="contact-icon" />
                  <div>
                    <h3>Email</h3>
                    <p>insurance@bereliable.in</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form-wrapper card">
              <h2>Send us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label className="form-label">Name *</label>
                  <input
                    type="text"
                    name="name"
                    className="form-input"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Mobile *</label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-input"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Message *</label>
                  <textarea
                    name="message"
                    className="form-textarea"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;


